import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Control, Form, Errors, actions } from 'react-redux-form'
import Popup from "reactjs-popup";
//import Screen from 'UI/CustomComponents/Screen';

// Actions
import { updateOrganization, addRevenue, updateCurrency, updateCurrencyCode, capIQFetchData, updateBPID, updateANID, updateValueStoryType,updateRegion } from 'actions/discoveryActions'

import {
	getSPCapitalIQData,
	getSPCapitalIQLoading,
	getSPCapitalIQSuccess,
	getSPCapitalIQFailure,
	getCapIQDataBlank,
	fetchIndirectVisibleSolutionInScopeValues,	
} from 'actions/spendActions'
import {
	fetchUserValueStories,
	fetchValueStories,
	fetchUserSharedValueStories,
	fetchValueStoriesLoading,
	fetchValueStoriesSuccess,
	fetchValueStoriesFailure,
	updateValueStoryFailure,
} from 'actions/userActions'
import {
	toggleValueDriver,
	toggleSubLever
} from 'actions/valueDriverActions'
import { updateUserInput } from 'actions/subLeverCalculationActions'

// Common Functions
import { subLeverChange } from 'components/BusinessValue/SubLeverChange'

// Utils
import { round, onChangeRemoveMask, formatThousands, getSubLeverIdObject, subLeverHasTotalSpend, removeMask, isDuplicate } from 'utils/Utils'

// Settings
import { validators, dropdownColourStyles } from 'Constants'

import DiscoveryCapIQSearch from './DiscoveryCapIQSearch';
import DiscoveryVsSearch from './DiscoveryVsSearch'
import { modalStyle, emailmodalContentStyle } from 'Constants'
import { ControlTextE, SelectE, CheckboxE, ScreenE, PopupE } from 'UI/CustomComponents/Controls';
import ANIdPicker from './ANIdPicker'
import BPIdPicker from './BPIdPicker'

const autoHeightModalStyle = Object.assign({}, modalStyle)
autoHeightModalStyle.height = 'auto'
autoHeightModalStyle.width = '30%'

const defaultOptions = [
	{ value: 0, label: "" }];

export class SpendDiscoveryForm extends PureComponent {

	constructor(props) {
		super(props)

		this.fetchValueStories = this.fetchValueStories.bind(this);
		this.fetchUserSharedValueStories = this.fetchUserSharedValueStories.bind(this);
		this.addCurrencyMask = this.addCurrencyMask.bind(this)
		this.calculateTotalSpendFromRevenue = this.calculateTotalSpendFromRevenue.bind(this)
		this.dispatchAddRevenue = this.dispatchAddRevenue.bind(this)
		this.getTotalSpend = this.getTotalSpend.bind(this)
		this.handleIndustryChange = this.handleIndustryChange.bind(this)
		this.handleLocationChange = this.handleLocationChange.bind(this)
		this.handleRegionChange = this.handleRegionChange.bind(this)
		this.handleCurrencyChange = this.handleCurrencyChange.bind(this)
		this.handleTotalSpendBlur = this.handleTotalSpendBlur.bind(this)
		this.repositionInputCaret = this.repositionInputCaret.bind(this)
		this.capIqRadioButtonClicked = this.capIqRadioButtonClicked.bind(this)
		this.anIdRadioButtonClicked = this.anIdRadioButtonClicked.bind(this)
		this.bpIdRadioButtonClicked = this.bpIdRadioButtonClicked.bind(this)
		this.capIqDataCleared = this.capIqDataCleared.bind(this)
		this.anIdDataCleared = this.anIdDataCleared.bind(this)
		this.bpIdDataCleared = this.bpIdDataCleared.bind(this)
		this.closeCapIqPopUp = this.closeCapIqPopUp.bind(this)
		this.closeANIDPopUp = this.closeANIDPopUp.bind(this)
		this.closeBPIDPopUp = this.closeBPIDPopUp.bind(this)
		this.closeVsListPopUp = this.closeVsListPopUp.bind(this)
		this.getSaveCode = this.getSaveCode.bind(this)
		this.getDisplayRegion = this.getDisplayRegion.bind(this)
		this.isZero = this.notZero.bind(this)
		this.value = 0
		this.totalSpendTouched = false
		this.annualRevenueCaret = 0
		this.annualRevenueThousandsSeparatorCount = 0
		this.annualRevenueValue = null
		this.totalSpendCaret = 0
		this.totalSpendThousandsSeparftorCount = 0
		this.totalSpendValue = null
		this.state = {
			industryOption: [],
			selectedIndustry: '',
			selectedIndirectScope: '',
			
			selectedLocation: '',
			locationOption: [],
			regionOption: [],
			currencyOption: [],
			selectedCurrency: '',
			selectedCurrencySymbol: '',
			showFloatingLabelFlag: false,
			selectedRegion: '',
			valueStory: '',
			isValueStoryNameEdit: false,
			organization: '',
			selectedCapIQCompanyId: '',
			open: false,
			closeCapIqPopUp: false,
			test: false,
			openVSList: false,
			valueStories: [],
			searchText: '',
			valueStoriesShared: [],
			isLoading: false,
			vsLoad: '',
			isCapIQLicesend: false,
			userValueStoryData: '',
			bpId: '',
			anId: '',
			indirectSolutionScopeOption: [],
			directSolutionScopeOption: [],
			valueStoryType: [
				{ value: 'Sales', label: 'Sales Values Story'},
		        {value: 'EnablementExecution', label: 'Enablement Value Story'}
			],
			selectedValueStoryType: '',
			openBPID: false,
			enabledANID_BPID: false,
		}
		this.onTextChangeEvent = this.onTextChangeEvent.bind(this);
		this.onValueStoryBlur = this.onValueStoryBlur.bind(this);
		this.onOrganizationChangeEvent = this.onOrganizationChangeEvent.bind(this);
		this.handleCapIQIdChange = this.handleCapIQIdChange.bind(this);
		this.onBPIDChangeEvent = this.onBPIDChangeEvent.bind(this);
		this.onANIDChangeEvent = this.onANIDChangeEvent.bind(this);
	}

	componentWillMount() {
		this.fetchUserValueStories();
		//if (this.props.newValueStory) {
		//this.dispatchAddRevenue(this.props.userData.AnnualRevenue)
		//}

		// Check for user inputted total spend
		const firstSubLeverTotalSpend = this.props.userData.BusinessValueToYou ? this.props.userData.BusinessValueToYou[0].ValueDriver[0].SubLever[0].UserInput[0].UserInput : null

		if (firstSubLeverTotalSpend !== '' && firstSubLeverTotalSpend !== null) this.totalSpendTouched = true

		
		this.setState({ valueStory: this.props.userData.ValueStoryName, organization: this.props.userData.Organization ,
			 bpId: this.props.userData.BPId, anId: this.props.userData.ANId });

		if (this.props.userData.CapIQCompany && this.props.userData.CapIQId) {
			this.setState({ selectedCapIQCompanyId: this.props.userData.CapIQCompany + ' | ' + this.props.userData.CapIQId }, this.callCapIQProcedure);
		}

		if (this.props.userData.Test !== undefined && this.props.userData.Test !== null) {
			this.setState({ test: this.props.userData.Test });
		}

		if ((this.props.userData.Industry !== "" || this.props.userData.Industry !== 0) && this.props.userData.Organization !== "" && this.props.userData.ValueStoryName !== "") {
			this.props.getCapIQDataBlank(false)
		} else {
			this.props.getCapIQDataBlank(true)
		}
	}

	componentDidMount() {
		this.loadData();
		//this.initialFieldValues();
		this.setState({ isCapIQLicesend: this.props.user.user.applicationFeatures.findIndex(a => a.Action === this.props.capIQ.capIQAction) > -1 ? true : false,
		enabledANID_BPID : this.props.user.userprofile !== undefined ? !this.props.user.userprofile.Roles[0].includes("Standard Internal User") : false })
		//////this.fetchUserSharedValueStories()
		//this.annualRevenueElement = document.getElementById('discovery.AnnualRevenue')
		//this.totalSpendInMillionsElement = document.getElementById('discovery.TotalSpend')

		this.bindIndustryAndLocation();


		if (this.props.content.industries.indexOf(this.props.content.industries[0]) === 0) {
			this.formDispatch(actions.setErrors('discovery.Industry', true))
		} else {
			this.formDispatch(actions.change('discovery.Industry', this.props.content.industries[this.props.userData.Industry]));
			this.formDispatch(actions.setErrors('discovery.Industry', false))
		}

		// set value story type default value 
		this.setState({ selectedValueStoryType: this.state.selectedValueStoryType !== undefined && this.state.selectedValueStoryType !== "" ? this.state.selectedValueStoryType : this.props.userData.ValueStoryType })


		// if (!validators.notZero(this.props.userData.AnnualRevenue) || this.props.userData.AnnualRevenue === '' || this.props.userData.AnnualRevenue === null) {
		// 	this.formDispatch(actions.setErrors('discovery.AnnualRevenue', {
		// 		required: validators.required(this.props.userData.AnnualRevenue) && this.props.validation.required,
		// 		isZero: (vals) => this.notZero(this.props.userData.AnnualRevenue) && this.props.validation.isZero
		// 	}))
		// } else {
		// 	this.formDispatch(actions.setErrors('discovery.AnnualRevenue', false))
		// }
	}

	isFormInvalid = () => {
		const { valueStory } = this.state;
	  
		// Blank Value Story
		if (!valueStory || valueStory.trim() === '') {
		  return true;
		}
	  
		// Duplicate Value Story
		if (
		  !isDuplicate(
			this.state.userValueStoryData,
			valueStory,
			this.props.userData.VSId
		  )
		) {
		  return true;
		}
	  
		// You can extend this later for other validations
		return false;
	  };

	componentWillUnmount() {
		// if (this.isFormInvalid()) {
		// 	const { originalUserData } = this.props;
		
		// 	this.setState({
		// 	  valueStory: originalUserData.ValueStoryName,
		// 	  organization: originalUserData.Organization,
		// 	  bpId: originalUserData.BPId,
		// 	  anId: originalUserData.ANId
		// 	});
		
		// 	this.props.dispatchUpdateValueStoryName(originalUserData.ValueStoryName);
		// 	this.props.dispatchUpdateOrganization(originalUserData.Organization);
		// 	this.props.dispatchUpdateBPID(originalUserData.BPId);
		// 	this.props.dispatchUpdateANID(originalUserData.ANId);
		// 	this.props.dispatchUpdateValueStoryType(originalUserData.ValueStoryType);
		
		// 	return; 
		//   }

		//Rollback value story updates if user doesn't click on Save button and jump to another screen.
		//This is required for Spend module NOT for Business Case because Save button is present for Spend module only.
		if (!this.props.isNewValueStory) {

			if ((this.props.originalUserData.VSId === this.props.userData.VSId) 
			&& !this.props.compareKeyValuesInObject(this.props.originalUserData, this.props.userData)) {

				if (this.props.userData.Industry !== this.props.originalUserData.Industry)
					this.handleIndustryChange(this.props.content.industries[this.props.originalUserData.Industry])

				if (this.props.userData.Location !== this.props.originalUserData.Location)
					this.handleLocationChange(this.props.content.locations[this.props.originalUserData.Location])

				if (this.props.userData.CapIQId !== this.props.originalUserData.CapIQId)
					this.props.dispatchUpdateCapIQId(this.props.originalUserData.CapIQId)

				if (this.props.userData.Organization !== this.props.originalUserData.Organization)
					this.props.dispatchUpdateOrganization(this.props.originalUserData.Organization)

				if (this.props.userData.ValueStoryName !== this.props.originalUserData.ValueStoryName)
					this.props.dispatchUpdateValueStoryName(this.props.originalUserData.ValueStoryName)

				if (this.props.userData.BPId !== this.props.originalUserData.BPId)
				this.props.dispatchUpdateBPID(this.props.originalUserData.BPId)
				
				if (this.props.userData.ANId !== this.props.originalUserData.ANId)
				this.props.dispatchUpdateANID(this.props.originalUserData.ANId)

				if (this.props.userData.ValueStoryType !== this.props.originalUserData.ValueStoryType)
					this.props.dispatchUpdateValueStoryType(this.props.originalUserData.ValueStoryType)
			}
		}

		
	}

	fetchUserValueStories() {
		this.props.fetchValueStoriesLoading(true)
		this.props.fetchUserValueStories(this.props.user.user.Id)
			.then((result) => {
				this.setState({userValueStoryData : result.data.Result})
				this.props.fetchValueStoriesSuccess(result)
				for (var i = 0; i < result.data.Result.length; i++) {
					var obj = result.data.Result[i];
					if (obj.Id !== localStorage.getItem('id')) {
						break;
					}
				}
				for (var i = 0; i < result.data.Result.length; i++) {
					var obj = result.data.Result[i];
					if (obj.Id === localStorage.getItem('id')) {
						break;
					}
				}
			}).catch((error) => {
				this.props.fetchValueStoriesFailure(error.response.data.Message)
			})
	}

	loadData() {

		var array = [
			{ label: 'Total Invoice spend', value: 'Total Invoice spend' },
			{ label: 'Total Invoice Count', value: 'Total Invoice Count' },
			{ label: 'Total Purchase Order Spend', value: 'Total Purchase Order Spend' },
			{ label: 'Total Purchase Order Count', value: 'Total Purchase Order Count' },
		]

		const group = { defaultValue: undefined, groupLabel: 'CapIqId', groupName: 'CapIqId' }
		

		/////// Load Indirect Solution in scope dropdown value ////////////////////
        this.props.fetchIndirectVisibleSolutionInScopeValues().then((response) => {
            if (response.status === 200) {
                if (response.data.Result.length > 0) {
                    
                    var indirectScopeValues=[];
					indirectScopeValues.push({ label: 'Select Scope', value: 'Select Scope' });					

                    if (response.data.Result !== null) {
						response.data.Result.forEach(item => {
							if (item.SOLUTION_IN_SCOPE_VALUE === 'Yes') {
								const value = item.SOLUTION_IN_SCOPE_NAME;
								const alreadyExists = indirectScopeValues.some(existing => existing.value === value);
					
								if (!alreadyExists) {
									indirectScopeValues.push({ label: value, value: value });
								}
							}
						});
					}
					
					let indirectScope = this.props.userData.IndirectSolutionScope;
					let directScope = this.props.userData.DirectSolutionScope;

                    this.setState({ indirectSolutionScopeOption: indirectScopeValues,selectedIndirectScope : indirectScope });
                }
			}
            
        }).catch((error) => {
            //this.setState({ responseMessage: this.props.content.errorMessage, isLoading: false, isError: true });
        })
        ///////////////////

		this.setState({
			group: group,
			items: array
		})

	}
	
	handleIndirectScopeChange(value) {
		this.props.dispatchIndirectScopeChange(this.props.content.indirectScopes.indexOf(value));
		this.props.userData.indirectScopeValues = value;
		this.setState({ selectedIndirectScope : value });
		this.formDispatch(actions.change('discovery.IndirectScope', value));
		if (value === 'Select Scope') {
			this.formDispatch(actions.setErrors('discovery.IndirectScope', true))
			this.formDispatch(actions.change('discovery.IndirectScope', ''));
		} else {
			this.formDispatch(actions.setErrors('discovery.IndirectScope', false))
		}	
	}	
	
	handleIndustryChange(value) {
		this.props.dispatchIndustryChange(this.props.content.industries.indexOf(value))
		const self = this;
		setTimeout(() => {
			if (!self.props.newValueStory) {
				let arr = []
				arr.push('4.3')
				arr.push('4.4')
				subLeverChange('', arr)
			}
			if (!this.totalSpendTouched) this.props.dispatchUpdateTotalSpend(this.calculateTotalSpendFromRevenue())
		}, 1)

		this.setState({ selectedIndustry : value });
		this.formDispatch(actions.change('discovery.Industry', value));


		if (this.props.content.industries.indexOf(this.props.content.industries[0]) === 0) {
			this.formDispatch(actions.setErrors('discovery.Industry', true))
			this.formDispatch(actions.change('discovery.Industry', ''));
		} else {
			this.formDispatch(actions.setErrors('discovery.Industry', false))
		}

		// added to make other spend tab disabled when this field are empty
		if (value !== this.props.content.industries[0] && this.props.userData.Organization !== "" && this.props.userData.ValueStoryName !== "") {
			this.props.getCapIQDataBlank(false)
		} else {
			this.props.getCapIQDataBlank(true)
		}

	}

	handleLocationChange(value) {
		var result = this.props.content.regions.find(region => region.Country.toLowerCase() == value.toLowerCase())
		this.props.dispatchLocationChange(this.props.content.locations.indexOf(value), result.Region)
		//this.getCurrency(this.props.content.locations.indexOf(value))

		var region = result.Region;
		region = region == 'NAMER' ? 'AMER': region;

		this.props.updateRegion(region);
		this.props.dispatchRegionChange(region);

		setTimeout(() => {
			if (!this.totalSpendTouched) this.props.dispatchUpdateTotalSpend(this.calculateTotalSpendFromRevenue())
		}, 1)

		this.setState({ selectedLocation: value ,selectedRegion: this.getDisplayRegion(region) });
	}

	getDisplayRegion = (code) => {
		if (code == null) {
			return 'North America';
		}
		else {
			const normalizedCode = code.toUpperCase();
			if (normalizedCode === 'AMER' || normalizedCode === 'NAMER') {
				return 'North America';
			} else if (normalizedCode === 'EMEA') {
				return 'Europe';
			}
			else if (normalizedCode === 'LAC') {
				return 'Latin America';
			}
			else if (normalizedCode === 'APJ') {
				return 'Asia Pacific Japan';
			}
			return '';
		}
	};

	getSaveCode = (region) => {
		switch (region) {
			case 'North America':
				return 'AMER'; // Save as AMER for consistency
			case 'Europe':
				return 'EMEA';
			case 'Asia Pacific Japan':
				return 'APJ';
			case 'Latin America':
				return 'LAC';
			default:
				return 'AMER';
		}
	};

	handleRegionChange(value) {
		this.props.updateRegion(value)
		this.props.dispatchRegionChange(value)
		this.setState({ selectedRegion: this.getDisplayRegion(value)});
	}

	handleCurrencyChange(value) {
		var result = this.state.currencyOption.find(currency => currency.value == value.value)
		//this.props.userData.CurrencyCode = value.value;
		//this.props.userData.Currency = this.props.currencySymbols[value.value];

		this.setState({ selectedCurrency: value });
		this.setState({ selectedCurrencySymbol: this.props.currencySymbols[value.value] });
		this.getCurrency(value);

		this.showModal("currencychange");
	}

	dispatchAddRevenue(revenue) {

		this.props.addRevenue(revenue)

		setTimeout(() => {
			if ((this.props.userData.TotalSpend === '' || this.props.userData.TotalSpend === null) || !this.totalSpendTouched)
				this.props.dispatchUpdateTotalSpend(this.calculateTotalSpendFromRevenue())

			this.repositionInputCaret('discovery.AnnualRevenue', this.annualRevenueCaret, this.annualRevenueThousandsSeparatorCount, this.props.userData.AnnualRevenue)
		}, 1)
	}

	calculateTotalSpendFromRevenue() {
		// Calculate Total Spend based on
		// Annual Revenue and Spend as Percentage of Revenue
		// if Annual Revenue is not empty
		if (this.props.userData.AnnualRevenue === '' || this.props.userData.AnnualRevenue === null) {
			return ''
		} else {
			//const totalSpend = round(this.props.spendAsPercentageOfRevenue / 100 * this.props.userData.AnnualRevenue, 2)
			const totalSpend = round(this.props.spendAsPercentageOfRevenue * this.props.userData.AnnualRevenue, 2)
			return totalSpend
		}
	}

	getTotalSpend(e) {
		this.totalSpendTouched = true
		const handleChange = this.props.handleChange

		let value = onChangeRemoveMask(e, this.state.selectedCurrencySymbol)

		// Total Spend user input is empty string or null
		if (!this.props.newValueStory && (value !== '' || value !== null)) {
			// Update Total Spend rows for all sub levers
			this.props.subLeverCalculationContent.forEach(function (obj) {

				const subLever = getSubLeverIdObject(obj.id)

				if (subLeverHasTotalSpend(obj.id)) {
					handleChange(value, subLever, 0)
				}
			})
		}

		// Update Total Spend in state
		this.props.dispatchUpdateTotalSpend(value)

		// Update controlled input
		this.props.dispatchTotalSpendChange(value)

		// add is-dirty state
		let el = document.getElementById("discovery.TotalSpend"),
			parent = el.parentNode
		parent.className += ' is-dirty'

		setTimeout(() => {
			// Update caret position
			if (this.totalSpendInMillionsElement === document.activeElement) {
				this.repositionInputCaret('discovery.TotalSpend', this.totalSpendCaret, this.totalSpendThousandsSeparatorCount, this.props.userData.TotalSpend)
			}
		}, 1)
	}

	handleTotalSpendBlur(e) {
		const handleChange = this.props.handleChange
		let value = onChangeRemoveMask(e, this.state.selectedCurrencySymbol)

		// Total Spend user input is empty string or null
		if (value === '' || value === null) {
			// Use default calculated Total Spend (Revenue * Industry BM percentage)
			value = this.calculateTotalSpendFromRevenue()


			// Clear Total Spend rows for all sub levers
			if (!this.props.newValueStory) {
				this.props.subLeverCalculationContent.forEach(function (obj) {

					const subLever = getSubLeverIdObject(obj.id)

					if (subLeverHasTotalSpend(obj.id)) {
						handleChange(null, subLever, 0)
					}
				})
			}
		}

		// Update Total Spend in state
		this.props.dispatchUpdateTotalSpend(value)

		// Update controlled input
		this.props.dispatchTotalSpendChange(value)
	}

	dispatchUpdateCurrency(currency) {
		let encodedCurrency = encodeURIComponent(currency)
		this.props.updateCurrency(encodedCurrency)
	}

	getCurrency(value) {
		this.dispatchUpdateCurrency(this.props.currencySymbols[value.value])
		this.props.updateCurrencyCode(value.value)
	}

	addCurrencyMask(value) {
		if (value === '' || value === null || value === '0') {

			if (this.formDispatch !== undefined) {
				this.formDispatch(actions.setErrors('discovery.AnnualRevenue', {
					required: validators.required(this.props.userData.AnnualRevenue) && this.props.validation.required,
					isZero: (vals) => this.notZero(this.props.userData.AnnualRevenue) && this.props.validation.isZero
				}))
				//this.formDispatch(actions.reset('discovery.AnnualRevenue'))
			}
			return ''
		} else {
			var temp = this.formDispatch !== undefined ? this.formDispatch(actions.setErrors('discovery.AnnualRevenue', false)) : null
			const regex = /\d*\.?\d{0,2}/g
			const filteredValue = regex.exec(value)

			if (filteredValue[0] === '') {
				return this.state.selectedCurrencySymbol + formatThousands(this.value) + ' M'
			} else {
				this.value = filteredValue[0]
				return this.state.selectedCurrencySymbol + formatThousands(this.value) + ' M'
			}
		}
	}

	repositionInputCaret(selector, lastCaretPosition, lastThousandsSeparatorCount, lastValue) {
		// Reposition Annual Revenue cursor after currency mask has been applied
		const el = document.getElementById(selector)
		if (!el) {
			return;
		}
		let val = el.value
		let thousandsSeparatorCount = val.split(",").length - 1
		let length = val.length

		let caretPosition = 0

		// Don't let caret go past Millions postfix
		if (lastCaretPosition >= val.length - 2) {
			el.selectionStart = length - 2
			el.selectionEnd = length - 2
			// If input is not empty
		} else if (el === document.activeElement && (lastValue.indexOf('M') > -1)) {
			if (thousandsSeparatorCount > lastThousandsSeparatorCount) {
				caretPosition = lastCaretPosition + 1
			} else if (thousandsSeparatorCount < lastThousandsSeparatorCount) {
				caretPosition = lastCaretPosition - 1
			} else {
				caretPosition = lastCaretPosition
			}

			el.selectionStart = caretPosition
			el.selectionEnd = caretPosition
			// If input is empty
		} else {
			el.selectionStart = length - 2
			el.selectionEnd = length - 2
		}

		//console.log('component did update', thousandsSeparatorCount, val, el.selectionStart, el.selectionEnd)
	}


	componentWillReceiveProps(nextProps) {
		/*
		Update Caret positions on user input
		 */
		// const val = this.annualRevenueElement.value
		// this.annualRevenueCaret = this.annualRevenueElement.selectionStart
		// this.annualRevenueThousandsSeparatorCount = val.split(",").length - 1
		// this.annualRevenueValue = val

		// const val2 = this.totalSpendInMillionsElement.value
		// this.totalSpendCaret = this.totalSpendInMillionsElement.selectionStart
		// this.totalSpendThousandsSeparatorCount = val2.split(",").length - 1
		// this.totalSpendValue = val2

		//console.log('component will receive props', this.annualRevenueThousandsSeparatorCount, el.value, el.selectionStart, el.selectionEnd)


		//bind industry option
		if (this.props.content !== nextProps.content) {
			this.props = nextProps;

			this.bindIndustryAndLocation();
		}
	}

	componentDidUpdate(nextProps, nextState) {
		// if (this.annualRevenueElement === document.activeElement) {
		// 	this.repositionInputCaret('discovery.AnnualRevenue', this.annualRevenueCaret, this.annualRevenueThousandsSeparatorCount, this.annualRevenueValue)
		// }

		// if (this.totalSpendInMillionsElement === document.activeElement) {
		// 	this.repositionInputCaret('discovery.TotalSpend', this.totalSpendCaret, this.totalSpendThousandsSeparatorCount, this.totalSpendValue)
		// }

		if (this.props !== undefined) {
			if (this.props.content.industries.indexOf(this.props.content.industries[this.props.userData.Industry]) > 0) {
				this.formDispatch(actions.change('discovery.Industry', this.props.content.industries[this.props.userData.Industry]));
			} else {
				this.formDispatch(actions.setErrors('discovery.Industry', true));
				this.formDispatch(actions.reset('discovery.Industry'));
			}

			// if (this.props.userData.AnnualRevenue === '' || this.props.userData.AnnualRevenue === null || this.props.userData.AnnualRevenue === '0') {

			// 	if (this.formDispatch !== undefined) {
			// 		this.formDispatch(actions.setErrors('discovery.AnnualRevenue', {
			// 			required: validators.required(this.props.userData.AnnualRevenue) && this.props.validation.required,
			// 			isZero: (vals) => this.notZero(this.props.userData.AnnualRevenue) && this.props.validation.isZero
			// 		}))
			// 		//this.formDispatch(actions.reset('discovery.AnnualRevenue'))
			// 	}
			// 	return ''
			// }
		}
	}

	bindIndustryAndLocation() {
		//bind industry option
		var array = [];
		this.props.content.industries.forEach((element) => {
			var obj = {};
			obj.label = element;
			obj.value = element;
			array.push(obj);
		});
		this.setState({ industryOption: array });

		// set default value for industry
		this.setState({ selectedIndustry: this.props.content.industries[this.props.userData.Industry] });

		//bind location option		
		var array1 = [];
		this.props.content.locations.forEach((element) => {
			var obj = {};
			obj.label = element;
			obj.value = element;
			array1.push(obj);
		});
		this.setState({ locationOption: array1 });

		//bind currency option		
		var array2 = [];
		let currencyCodes = this.props.content.currencyCodes;
		for (let i = 1; i < currencyCodes.length; i++) {
			let obj = { label: currencyCodes[i], value: currencyCodes[i].split(' - ')[0] }
			array2.push(obj);
		}
		this.setState({ currencyOption: array2 });

		var array3 = [];
		this.props.content.regionsList.forEach((element) => {
			var obj = {};
			obj.label = element.Region;
			obj.value = element.Region_Code;
			array3.push(obj);
		});
		this.setState({ regionOption: array3 });

		//var result = this.props.content.regions.find(region => region.Country.toLowerCase() == this.props.content.locations[this.props.userData.Location].toLowerCase())
		
		// set default value for location		
		this.setState({ selectedLocation: this.props.userData.Country_Name, selectedRegion: this.getDisplayRegion(this.props.userData.Region)});
		this.props.dispatchLocationChange(this.props.userData.Location, this.props.userData.Region)

		var idx = array2.findIndex((element) => {
			return element.value === this.props.userData.CurrencyCode
		})

		if (idx === -1) {
			idx = array2.findIndex((element) => {
				return element.value === 'USD'
			})
		}

		let selectedCurrencySym = this.props.currencySymbols[array2[idx].value];

		this.getCurrency({ label: selectedCurrencySym, value: array2[idx].value })


		//this.dispatchUpdateCurrency(selectedCurrencySym);

		this.setState({ selectedCurrencySymbol: selectedCurrencySym });
		// set default value for currency 
		this.setState({ selectedCurrency: array2[idx] });
	}



	// onTextChangeEvent(event) {
	// 	this.setState({ valueStory: event.target.value !== undefined ? event.target.value : this.props.userData.ValueStoryName });
	// 	this.props.userData.ValueStoryName = event.target.value;
	// 	this.setState({ isValueStoryNameEdit: true });

	// 	if ((event.target.value !== undefined && event.target.value !== "") && this.props.userData.Industry !== this.props.content.industries[0]
	// 		&& this.props.userData.Organization !== "") {
	// 		this.props.getCapIQDataBlank(false)
	// 	} else {
	// 		this.props.getCapIQDataBlank(true)
	// 	}
	// }

	onValueStoryBlur = (event) => {
		const value = event.target.value || '';
		const { originalUserData } = this.props;
	  
		// If user cleared the field, restore original value
		if (value === '' && originalUserData && originalUserData.ValueStoryName) {
		  this.setState({
			valueStory: originalUserData.ValueStoryName
		  });
	  
		  // Update redux properly
		  this.props.dispatchUpdateValueStoryName(
			originalUserData.ValueStoryName
		  );
		}
	  };

	onTextChangeEvent(event) {
		const value = event.target.value || '';
	  
		// local state for UI + validation
		this.setState({
		  valueStory: value,
		  isValueStoryNameEdit: true
		});
	  
		// ✅ proper Redux update (this enables Save button)
		this.props.dispatchUpdateValueStoryName(value);
	  
		if (
		  value !== "" &&
		  this.props.userData.Industry !== this.props.content.industries[0] &&
		  this.props.userData.Organization !== ""
		) {
		  this.props.getCapIQDataBlank(false);
		} else {
		  this.props.getCapIQDataBlank(true);
		}
	  }

	onOrganizationChangeEvent(event) {
		this.setState({ organization: event.target.value !== undefined ? event.target.value : this.props.userData.Organization });
		this.props.userData.Organization = event.target.value;
		this.props.updateOrganization(this.props.userData.Organization);
		this.setState({ isOrganizationEdit: true });

		if ((event.target.value !== undefined && event.target.value !== "") && this.props.userData.Industry !== this.props.content.industries[0]
			&& this.props.userData.ValueStoryName !== "") {
			this.props.getCapIQDataBlank(false)
		} else {
			this.props.getCapIQDataBlank(true)
		}
	}

	onBPIDChangeEvent(event){
        this.setState({ bpId: event.target.value !== undefined ? event.target.value : this.props.userData.BPId });
		this.props.userData.BPId = event.target.value;
		this.props.updateBPID(this.props.userData.BPId);
	}

	onANIDChangeEvent(event){
		this.setState({ anId: event.target.value !== undefined ? event.target.value : this.props.userData.ANId });
		this.props.userData.ANId = event.target.value;
		this.props.updateANID(this.props.userData.ANId);
	}

	handleCapIQIdChange(event) {
		this.setState({ capIQId: event.target.value !== undefined ? event.target.value : this.props.userData.CapIQId });
		this.props.userData.CapIQId = event.target.value;
		this.setState({ isCapIQIdEdit: true });
	}

	handleValueStoryTypeChange(data){
		this.props.updateValueStoryFailure("")
		this.props.userData.ValueStoryType = data.value
		this.setState({ selectedValueStoryType : data.value})
		this.props.updateValueStoryType(this.props.userData.ValueStoryType)
	}

	notZero(vals) {
		if ((vals !== null && vals !== '' && Number.parseFloat(removeMask(vals, this.state.selectedCurrencySymbol)) === 0)) {
			return false;
		}

		return true;
	}

	closeCapIqPopUp() {
		this.setState({ openCapIq: !this.state.openCapIq })
	}

	closeANIDPopUp() {
		this.setState({ openANID: !this.state.openANID })
	}

	closeBPIDPopUp() {
		this.setState({ openBPID: !this.state.openBPID })
	}

	closeVsListPopUp() {
		this.setState({ openVSList: !this.state.openVSList, vsLoad: '' })
	}

	callCapIQProcedure() {
		let str = this.state.selectedCapIQCompanyId
		let id = str.split('|').pop().trim()
		this.props.dispatchCapIQChange(id)
		// this.props.getSPCapitalIQData(id)
		//     .then((result) => {
		//         this.props.getSPCapitalIQSuccess(result)
		// 		this.props.capIQFetchData(result.data.Result[0])
		//     }).catch((error) => {
		//         this.props.getSPCapitalIQFailure(error.response.data.Message)
		//     })
	}

	capIqDataCleared() {
		var array2 = [];
		let currencyCodes = this.props.content.currencyCodes;
		for (let i = 1; i < currencyCodes.length; i++) {
			let obj = { label: currencyCodes[i], value: currencyCodes[i].split(' - ')[0] }
			array2.push(obj);
		}
		this.setState({ currencyOption: array2 });
		let idx = array2.findIndex((element) => {
			return element.value === 'USD'
		})


		let selectedCurrencySym = this.props.currencySymbols[array2[idx].value];

		this.getCurrency({ label: selectedCurrencySym, value: array2[idx].value })


		//this.dispatchUpdateCurrency(selectedCurrencySym);

		this.setState({ selectedCurrencySymbol: selectedCurrencySym });
		// set default value for currency 
		this.setState({ selectedCurrency: array2[idx] });
		this.props.dispatchCapIQChange('clear');

		var result = this.props.content.regions.find(region => region.Country.toLowerCase() == this.props.content.locations[0].toLowerCase())
		this.setState({ capIQId: '', selectedCapIQCompanyId: '', selectedLocation: this.props.content.locations[0], selectedIndustry: this.props.content.industries[0],selectedRegion : result.Region })
	}

	capIqRadioButtonClicked(data) {
		this.props.userData.CapIQId = data.COMPANY_ID
		this.props.userData.CapIQCompany = data.COMPANY_NAME
		this.props.userData.Organization = data.COMPANY_NAME
		this.bindIndustryAndLocation()
		this.formDispatch(actions.change('discovery.Organization', data.COMPANY_NAME));
		if (this.props.userData.CapIQCompany) {
			this.setState({ selectedCapIQCompanyId: this.props.userData.CapIQCompany + ' | ' + this.props.userData.CapIQId, organization: data.COMPANY_NAME }, this.callCapIQProcedure);
		} else {
			this.setState({ selectedCapIQCompanyId: '' })
		}

		this.props.userData.AnnualRevenue = data.COMPANY_REVENUE ? data.COMPANY_REVENUE + '' : null;
		this.dispatchAddRevenue(this.props.userData.AnnualRevenue)
		//this.props.userData.Location = data.COUNTRY_NAME
		let idx = this.props.content.locations.findIndex(item => data.COUNTRY_NAME.toLowerCase() === item.toLowerCase())
		if (idx !== -1) {
			this.props.userData.Location = idx;
			var result = this.props.content.regions.find(region => region.Country.toLowerCase() == data.COUNTRY_NAME.toLowerCase())
			this.props.dispatchLocationChange(idx, result.Region)
			this.setState({ selectedLocation: this.props.content.locations[idx],selectedRegion : result.Region });
		} else {
			var result = this.props.content.regions.find(region => region.Country.toLowerCase() == this.props.content.locations[0].toLowerCase())
			this.setState({ selectedLocation: this.props.content.locations[0],selectedRegion : result.Region })
		}

		if (data.AVATAR_INDUSTRY) {
			const industryIdx = this.props.content.industries.findIndex(item => data.AVATAR_INDUSTRY.toLowerCase() === item.toLowerCase());
			if (industryIdx !== -1) {
				this.props.userData.Industry = industryIdx;
				this.formDispatch(actions.change('discovery.Industry', this.props.content.industries[industryIdx]));
				//this.props.dispatchIndustryChange(this.props.content.industries[industryIdx])
				this.setState({ selectedIndustry: this.props.content.industries[industryIdx] });
			} else {
				this.setState({ selectedIndustry: this.props.content.industries[0] });

			}
		}

		if (this.state.organization !== "" && this.props.content.industries[this.props.userData.Industry] !== this.props.content.industries[0]) {
			this.props.getCapIQDataBlank(false)
		} else {
			this.props.getCapIQDataBlank(true)
		}
	}

	anIdRadioButtonClicked(data) {
		this.props.userData.ANId = data.BUYER_ANID	
		this.props.userData.BPId = this.props.userData.BPId === undefined || this.props.userData.BPId === "" ? data.BPID : this.props.userData.BPId	
		this.formDispatch(actions.change('discovery.ANID', data.BUYER_ANID));
		this.formDispatch(actions.change('discovery.BPID', data.BPID));
		this.props.getCapIQDataBlank(false)
		this.setState({ openANID: !this.state.openANID })
	}

	anIdDataCleared() {	
		this.formDispatch(actions.change('discovery.ANID', ''));
		this.props.userData.ANId = ''	
		this.closeANIDPopUp()
	}

	bpIdRadioButtonClicked(data) {
		this.props.userData.BPId = data.BPID
		this.formDispatch(actions.change('discovery.BPID', data.BPID));
		this.props.getCapIQDataBlank(false)
		this.setState({ openBPID: !this.state.openBPID })
	}

	bpIdDataCleared() {	
		this.formDispatch(actions.change('discovery.BPID', ''));
		this.props.userData.BPId = ''	
		this.closeBPIDPopUp()
	}

	showModal(action) {
		this.refs[action].show()
	}

	hideModal(action) {
		this.refs[action].hide()
	}

	selectIsTestChk(e) {
		this.setState({ test: !this.state.test }, () => {
			this.props.userData.Test = this.state.test;
		});
	}
	fetchUserSharedValueStories() {
		this.props.fetchValueStoriesLoading(true)
		this.setState({ isError: false, message: '', })
		this.props.fetchUserSharedValueStories(this.props.user.user.Id)
			.then((result) => {
				this.props.fetchValueStoriesSuccess(result)
				var obj = [];
				for (var i = 0; i < result.data.Result.length; i++) {

					obj.push(result.data.Result[i])
				}
				let temp = obj;
				temp.forEach((element, i) => {
					element.content = false;
					element.index = i;
				});
				this.setState({ valueStoriesShared: temp })
			}).catch((error) => {
				this.props.fetchValueStoriesFailure(error.response.data.Message)
				this.setState({
					message: error.response.data.Message, isLoading: false, isError: true
				})
			})
	}
	fetchValueStories() {
		let searchText = this.state.organization;
		let prevText = this.state.searchText;
		let sharedVs = this.state.valueStoriesShared;
		if (searchText != prevText) {
			this.props.fetchValueStoriesLoading(true)
			this.setState({ isError: false, message: '', vsLoad: 'true' })
			this.props.fetchValueStories(searchText)
				.then((result) => {
					this.props.fetchValueStoriesSuccess(result)
					var obj = [];
					for (var i = 0; i < result.data.Result.length; i++) {

						obj.push(result.data.Result[i])
					}
					let temp = obj;
					let vsList;
					temp.forEach((element, i) => {
						element.content = false;
						element.index = i;
					});
					if (sharedVs.length > 0) {
						vsList = temp.filter(obj => !sharedVs.filter(xobj => obj.VSID == xobj.VSId).length)
					}
					this.setState({ valueStories: vsList, searchText: searchText, vsLoad: '' })
				}).catch((error) => {
					this.props.fetchValueStoriesFailure(error.response.data.Message)
					this.setState({
						message: error.response.data.Message, isLoading: false, isError: true
					})
				})
		}
	}

	render() {
		return (
			<ScreenE readOnly={!this.props.userData.AllowEdit} lastUpdated={new Date().getTime()}>
				<div>
					<div>
						<div className="grid-x">
							<div className="medium-4 medium-offset-8" style={{ textAlign: 'right', height: '20px' }}>
								{
									this.props.userData.VSId !== undefined ? this.props.content.vsId + ": " + this.props.userData.VSId : null
								}
							</div>
						</div>
						<div className="grid-x">
							<div className="medium-7">
								{this.state.organization}
							</div>
							<div className="medium-5">
								<div className="float-right">
									<div className="float-left width30">
										<CheckboxE checked={this.state.test} onClick={(e) => this.selectIsTestChk(e)} />
									</div>
									<div className="float-left line-height25 test-label">{this.props.content.testValueStory}</div>
								</div>
							</div>
						</div>
					</div>
					<div className="formBg">
						<Form model="discovery" method="post"
							// validators={{
							// 	AnnualRevenue: (vals) => this.notZero(this.props.userData.AnnualRevenue)
							// }}
							getDispatch={(dispatch) => this.formDispatch = dispatch}>
							<div className="grid-x" key="1">
								<div className="mandatory-text medium-12 large-12">
									<span className="asterisk">*</span> {this.props.content.mandatoryFields}
								</div>
							</div>
							<div className="grid-x" key="2">
								<div className="medium-12 large-12" key="5">
									<div className="label" key="">{this.props.content.valueStoryName} <span className="asterisk">*</span></div>
									<div className="control-wrapper">
										<ControlTextE
											model="discovery.ValueStoryName"
											id="discovery.ValueStoryName"
											value={this.state.valueStory}
											disabled = {this.props.userData.Id !== undefined && this.props.userData.Id !== null && this.props.userData.Id !== this.props.user.user.Id}
											defaultValue={this.state.valueStory}
											onChange={this.onTextChangeEvent}
											onBlur={this.onValueStoryBlur}
											validators={{
												required: validators.required
												, duplicate: (vals) => isDuplicate(this.state.userValueStoryData, vals, this.props.userData.VSId)
											}}
											validateOn="change"
										/>
										<Errors
											className="errors"
											model="discovery.ValueStoryName"
											show="touched"
											messages={{
												required: this.props.validation.required
												, duplicate: this.props.validation.duplicateValueStoryName
											}}
										/>
									</div>
								</div>
							</div>
							<div className="grid-x row" key="3">
							{this.state.isCapIQLicesend ?								
								<div className="medium-12 large-12">
									{/* <div className="label">{this.props.content.capIQId}</div>
									<div>
                                       <Popup className="report-tooltip"
                                           trigger={<span className='value__information' />}
                                           position="bottom right"
                                           on="hover"
                                       >
                                           {this.props.content.capIQId}
                                       </Popup>
                                   </div> */}
										<div className="grid-x">
											<div className="label" style={{ paddingTop: '4px' }}>
												{this.props.content.capIQId}
											</div>
											<div >
												<div className="float-left">
													<Popup className="report-tooltip"
														trigger={<span className='value__information' />}
														position="bottom left"
														on="hover"
													>
														{this.props.content.capIQId_helpText}
													</Popup>
												</div>
											</div>
										</div>
										<div className="control-wrapper capIq-popup">
											<ControlTextE
												model="discovery.CapIQId"
												id="discovery.CapIQId"
												value={this.state.selectedCapIQCompanyId}
												defaultValue={this.state.selectedCapIQCompanyId}
												title={this.state.selectedCapIQCompanyId}
												onChange={this.handleCapIQIdChange}
												readOnly={true}
											/>
											{
												<PopupE className="large-popup"
													trigger={
														<img Style="cursor: pointer" className="control-image" width="15" src="/images/search_big_inactive.svg" />}
													position="right center"
													open={this.state.openCapIq}
													onOpen={this.closeCapIqPopUp}
													closeOnDocumentClick
												>
													<div>
														<DiscoveryCapIQSearch
															contentData={this.props.content}
															capIqRadioButtonClicked={this.capIqRadioButtonClicked}
															capIqDataCleared={this.capIqDataCleared}
															close={this.closeCapIqPopUp}
														/>
													</div>
												</PopupE>
											}
										</div>
								</div> : null}
							</div>
							<div className="grid-x row" key="4">
								<div className="medium-12 large-12">
									<div className="label">{this.props.content.company} <span className="asterisk">*</span></div>
									<div className="control-wrapper">
										<ControlTextE
											model="discovery.Organization"
											id="discovery.Organization"
											value={this.props.userData.Organization}
											// defaultValue={this.props.userData.Organization}
											onChange={this.onOrganizationChangeEvent}
											validators={{
												required: validators.required
											}}
											validateOn="change"
										/>
										<Errors
											className="errors"
											model="discovery.Organization"
											show="touched"
											messages={{
												required: this.props.validation.required
											}}
										/>
									</div>
								</div>
							</div>                           

							<div className="grid-x row" key="5">
								<div className="medium-12 large-12">
									<div className="label">{"ANID"} </div>
									<div className="control-wrapper capIq-popup">
									    <ControlTextE
											model="discovery.ANID"
											id="discovery.ANID"
											value={this.props.userData.ANId}
											onChange={this.onANIDChangeEvent}
											disabled = {this.state.enabledANID_BPID} 
											defaultValue={this.props.userData.ANId}										
										/>
											{
												<PopupE className="large-popup" style={{ height:'400px'}}
													trigger={
														<img Style="cursor: pointer" className="control-image" width="15" src="/images/search_big_inactive.svg" />}
													position="right center"
													open={this.state.openANID}
													onOpen={this.closeANIDPopUp}
													closeOnDocumentClick
													disabled= {this.state.enabledANID_BPID}
												>
													<div>
														<ANIdPicker
															contentData={this.props.content}
															anIdRadioButtonClicked={this.anIdRadioButtonClicked}
															clearANID={this.anIdDataCleared}
															close={this.closeANIDPopUp}
														/>
													</div>
												</PopupE>
											}
										
									</div>
								</div>
							</div>

							<div className="grid-x row" key="6">
								<div className="medium-12 large-12">
									<div className="label">{"BPID"} </div>
									<div className="control-wrapper capIq-popup">
									    <ControlTextE
											model="discovery.BPID"
											id="discovery.BPID"
											value={this.props.userData.BPId}
											onChange={this.onBPIDChangeEvent}
											disabled = {this.state.enabledANID_BPID} 
											defaultValue={this.props.userData.ValueStoryCreator}										
										/>
											{
												<PopupE className="large-popup" style={{ height:'400px'}}
													trigger={
														<img Style="cursor: pointer" className="control-image" width="15" src="/images/search_big_inactive.svg" />}
													position="right center"
													open={this.state.openBPID}
													onOpen={this.closeBPIDPopUp}
													closeOnDocumentClick
													disabled= {this.state.enabledANID_BPID}
												>
													<div>
														<BPIdPicker
															contentData={this.props.content}
															bpIdRadioButtonClicked={this.bpIdRadioButtonClicked}
															clearBPID={this.bpIdDataCleared}
															close={this.closeBPIDPopUp}
														/>
													</div>
												</PopupE>
											}
										
									</div>
								</div>
							</div>
											 
							{/* <div className="grid-x row" key="11">
								<div className="medium-12 large-12">
									<div className="label">{this.props.content.indirectScopeLabel}<span className="asterisk">*</span></div>
									<div className="control-wrapper">
										<SelectE
											className="border-less-DD"
											model="discovery.IndirectScope"
											id="discovery.IndirectScope"
											name="discovery.IndirectScope"
											placeholder={this.props.content.indirectScopeLabel}
											value={this.state.indirectSolutionScopeOption.filter(option => option.label === this.state.selectedIndirectScope)}
											noOptionsMessage={() => null}
											onChange={(value) => this.handleIndirectScopeChange(value.label)}
											validators={{ required: (value) => validators.validSelect(this.props.content.indirectScopes.indexOf(value.label)) }}
											validateOn="change"
											options={this.state.indirectSolutionScopeOption}
											isSearchable={false} styles={dropdownColourStyles}
										/>
										<Errors
											className="errors errorsMargin"
											model="discovery.IndirectScope"
											//show="touched"
											messages={{
												required: this.props.validation.required
											}}
										/>
										<ControlTextE
											model="discovery.IndirectScope"
											id="discovery.IndirectScope1"
											hidden
											value={this.state.selectedIndirectScope}
											defaultValue={this.state.selectedIndirectScope}
											validators={{
												required: (value) => validators.validIndirectScope(this.state.selectedIndirectScope)
											}}
											validateOn="change"
										/>
									</div>
								</div>
							</div>							 */}

							<div className="grid-x row" key="7">
								<div className="medium-12 large-12">
									<div className="label">{this.props.content.industriesLabel} <span className="asterisk">*</span></div>
									<div className="control-wrapper">
										<SelectE
											className="border-less-DD"
											model="discovery.Industry"
											id="discovery.Industry"
											name="discovery.Industry"
											placeholder={this.props.content.industriesLabel}
											value={this.state.industryOption.filter(option => option.label === this.state.selectedIndustry)}
											noOptionsMessage={() => null}
											onChange={(value) => this.handleIndustryChange(value.label)}
											validators={{ required: (value) => validators.validSelect(this.props.content.industries.indexOf(value.label)) }}
											validateOn="change"
											options={this.state.industryOption}
											isSearchable={false} styles={dropdownColourStyles}
										/>
										<Errors
											className="errors errorsMargin"
											model="discovery.Industry"
											//show="touched"
											messages={{
												required: this.props.validation.required
											}}
										/>
										<ControlTextE
											model="discovery.Industry"
											id="discovery.Industry1"
											hidden
											value={this.state.selectedIndustry}
											defaultValue={this.state.selectedIndustry}
											validators={{
												required: (value) => validators.validIndustry(this.state.selectedIndustry)
											}}
											validateOn="change"
										/>
									</div>
								</div>
							</div>
							<div className="grid-x row" key="8">
								<div className="medium-12 large-12">
									<div className="label">{this.props.content.locationsLabel} <span className="asterisk">*</span></div>
									<div className="control-wrapper">
										<SelectE
											className="border-less-DD"
											model="discovery.Location"
											id="discovery.Location"
											placeholder={this.props.content.locationsLabel}
											value={this.state.locationOption.filter(option => option.label === this.state.selectedLocation)}
											noOptionsMessage={() => null}
											onChange={(value) => this.handleLocationChange(value.label)}
											options={this.state.locationOption}
											isSearchable={false}
											validators={{
												required: validators.required
											}}
											validateOn="change" styles={dropdownColourStyles}
										/>
										<Errors
											className="errors errorsMargin"
											model="discovery.Location"
											show="touched"
											messages={{
												required: this.props.validation.required
											}}
										/>
									</div>
								</div>
							</div>

							<div className="grid-x row" key="88">
								<div className="medium-12 large-12">
									<div className="label" style={{ width: '100%' }}>{this.props.content.regionsLabel} <span className="asterisk">*</span>
										<span style={{ float: 'right' }}>
											<Popup
												className="report-tooltip"
												trigger={
													<img
														style={{ marginLeft: '5px', paddingBottom: '0px' }}
														className="info-icon"
														src="images/info-icon.svg"
														width="15"
													/>
												}
												position="bottom left"
												on="hover"
												contentStyle={{
													maxWidth: '300px',
													whiteSpace: 'normal',
													wordWrap: 'break-word',
													overflowWrap: 'break-word',
													padding: '10px',
													zIndex: 1000,
												}}
											>
												<div>
												Regional Model is changed on the Spend Parameters Sub-Tab. The Regional Model field is auto populated based on the user region by default, when you change the country the Regional Model updates.  This field selects the Regional Model used to populate the Enablement Recommendations which flow through to the Onboarding Workstream and Enablement Waves.
												</div>
											</Popup>
										</span>
									</div>
									<div className="control-wrapper" style={{ pointerEvents: 'none', opacity: 0.6 }}>
										{/* <SelectE
											className="border-less-DD"
											model="discovery.Region"
											id="discovery.Region"
											placeholder={this.props.content.regionsLabel}
											value={this.state.regionOption.filter(option => option.value === this.state.selectedRegion)}
											noOptionsMessage={() => null}
											onChange={(value) => this.handleRegionChange(this.getSaveCode(value.value))}
											options={this.state.regionOption}
											isSearchable={false}
											validators={{
												required: validators.required
											}}
											validateOn="change" styles={dropdownColourStyles}
										/>
										<Errors
											className="errors errorsMargin"
											model="discovery.Region"
											show="touched"
											messages={{
												required: this.props.validation.required
											}}
										/> */}
										<ControlTextE
											model="discovery.Region"
											id="discovery.Region"
											value={this.state.selectedRegion}
											disabled = {true} 
											defaultValue={this.state.selectedRegion}										
										/>
									</div>
								</div>
							</div>

							<div  className="grid-x row" key="9">
								<div className="medium-12 large-12">
									<div className="label" style={{ width: '100%' }}>{"Value Story Type"} <span className="asterisk">*</span>
										<span style={{ float: 'right' }}>
											<Popup
												className="report-tooltip"
												trigger={
													<img
														style={{ marginLeft: '5px', paddingBottom: '0px' }}
														className="info-icon"
														src="images/info-icon.svg"
														width="15"
													/>
												}
												position="bottom left"
												on="hover"
												contentStyle={{
													maxWidth: '300px',
													whiteSpace: 'normal',
													wordWrap: 'break-word',
													overflowWrap: 'break-word',
													padding: '10px',
													zIndex: 1000,
												}}
											>
												<div>
													The Value Story Type field drives the functionality available in the Value Story.  Match Only request files can only have a Sales Value Story.
												</div>
											</Popup>
										</span>
									</div>
									<div className="control-wrapper">
										<SelectE
											className="border-less-DD"
											model="discovery.ValueStoryType"
											id="discovery.ValueStoryType"
											placeholder={"Select Value Story Type"}
											value={this.state.valueStoryType.filter(option => option.value === this.state.selectedValueStoryType)}
											noOptionsMessage={() => null}
											onChange={(value) => this.handleValueStoryTypeChange(value)}
											options={this.state.valueStoryType}
											isSearchable={false}
											validators={{
												required: validators.required
											}}
											//isDisabled={true}
											isDisabled={this.props.spendDetails.vsTypeDirecConnect == 'Sales'}
											validateOn="change" styles={dropdownColourStyles}
										/>
										<Errors
											className="errors errorsMargin"
											model="discovery.ValueStoryType"
											show="touched"
											messages={{
												required: this.props.validation.required
											}}
										/>
									</div>
									</div>
								</div>

                            { this.props.userData.VSId !== undefined ?
							<div className="grid-x row" key="10">
								<div className="medium-12 large-12">
									<div className="label">{"Creator"} </div>
									<div className="control-wrapper">
									    <ControlTextE
											model="discovery.ValueStoryCreator"
											id="discovery.ValueStoryCreator"
											value={this.props.userData.ValueStoryCreator}
											disabled = {true} 
											defaultValue={this.props.userData.ValueStoryCreator}										
										/>
										
									</div>
								</div>
							</div>
							: null }
							{ this.props.userData.VSId !== undefined ?
							<div className="grid-x row" key="11">
								<div className="medium-12 large-12">
									<div className="label">{"Owner"} </div>
									<div className="control-wrapper">
									    <ControlTextE
											model="discovery.ValueStoryOwner"
											id="discovery.ValueStoryOwner"
											value={this.props.userData.ValueStoryOwner}
											disabled = {true} 
											defaultValue={this.props.userData.ValueStoryOwner}										
										/>
										
									</div>
								</div>
							</div>
							: null }
							{/* <div className="grid-x row"  key="7">
								<div className="medium-12 large-12">
									<div className="label">{this.props.content.currency} <span className="asterisk">*</span></div>
									<div className="control-wrapper">
										<SelectE
											className="border-less-DD"
											model="discovery.CurrencyCode"
											id="discovery.CurrencyCode"
											placeholder={this.props.content.currencyCodes[0]}
											value={this.state.currencyOption.filter(option => option.value === this.state.selectedCurrency.value)}
											noOptionsMessage={() => null}
											onChange={(value) => this.handleCurrencyChange(value)}
											options={this.state.currencyOption}
											isSearchable={false}
											validators={{
												required: validators.required
											}}
                                            validateOn="change" styles={dropdownColourStyles}
                                            
										/>
										<Modal
											ref={'currencychange'}
											keyboard={() => this.callback()}
											modalStyle={autoHeightModalStyle}
											contentStyle={emailmodalContentStyle}>
											<div className="grid-x">
												<div className="medium-12">
													{this.props.content.currencyChangeAlert}
												</div>
												<div className="medium-12 popupOkBtn">
													<div className="float-right">
														<Button onClick={() => this.hideModal("currencychange")}
															content='OK'
														/>
													</div>
												</div>
											</div>
										</Modal>
									</div>
								</div>
							</div> */}
							{/* <div className="grid-x row"  key="8">
								<div className="medium-12 large-12">
									<div className="label">{this.props.content.revenue} <span className="asterisk">*</span></div>
									<div className="control-wrapper">
										<ControlTextE
											model="discovery.AnnualRevenue"
											id="discovery.AnnualRevenue"
											value={this.addCurrencyMask(this.props.userData.AnnualRevenue)}
											defaultValue={this.addCurrencyMask(this.props.userData.AnnualRevenue)}
											onChange={e => { this.dispatchAddRevenue(onChangeRemoveMask(e, this.state.selectedCurrencySymbol)) }}
											validators={{
												required: validators.required,
												isZero: (vals) => this.notZero(this.props.userData.AnnualRevenue)

											}}
                                            hidden
											validateOn="change"
										/>
										<Errors
											className="errors"
											model="discovery.AnnualRevenue"
											show="touched"
											messages={{
												required: this.props.validation.required,
												isZero: this.props.validation.isZero
											}}
										/>
									</div>
								</div>
							</div>
							<div className="grid-x row"  key="9">
								<div className="medium-12 large-12">
									<div className="label">{this.props.content.spend}</div>
									<div className="control-wrapper">
										<ControlTextE
											model="discovery.TotalSpend"
											id="discovery.TotalSpend"
											value={this.addCurrencyMask(this.props.userData.TotalSpend)}
											defaultValue={this.addCurrencyMask(this.props.userData.TotalSpend)}
											onChange={(e) => { this.getTotalSpend(e) }}
                                            onBlur={(e) => this.handleTotalSpendBlur(e)}
                                            hidden
										/>
									</div>
								</div>
							</div> */}
						</Form>
					</div>
				</div>
			</ScreenE>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		user: state.default,
		currency: decodeURIComponent(state.valueStory ? state.valueStory.Currency : state.companyProfileData[0].currencyCode),
		spendAsPercentageOfRevenue: state.spendAsPercentageOfRevenue,
		validation: state.content.validation,
		contentPE: state.contentPE,
		companyData: state.companyProfileData,
		selectedValueStory: state.selectedValueStory,
		currencySymbols: state.content.CurrencySymbols,
		userData: state.valueStory,
		newValueStory: state.isNewValueStory,
		searchResultData: state.searchResultData,
		capIQ: state.content.spendAnalysis.detailedFile,
		spendDetails: state.spendDetails
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		fetchUserValueStories: (id) => dispatch(fetchUserValueStories(id)),
		fetchValueStoriesLoading: (bool) => dispatch(fetchValueStoriesLoading(bool)),
		fetchValueStoriesSuccess: (valueStories) => dispatch(fetchValueStoriesSuccess(valueStories)),
		fetchValueStoriesFailure: (error) => dispatch(fetchValueStoriesFailure(error)),
		updateOrganization: (revenue) => dispatch(updateOrganization(revenue)),
		addRevenue: (revenue) => dispatch(addRevenue(revenue)),
		updateCurrency: (currency) => dispatch(updateCurrency(currency)),
		updateCurrencyCode: (currencyCode) => dispatch(updateCurrencyCode(currencyCode)),
		toggleValueDriver: (id, bool) => dispatch(toggleValueDriver(id, bool)),
		toggleSubLever: (id, bool) => dispatch(toggleSubLever(id, bool)),
		handleChange: (value, subLeverId, rowNumber) => dispatch(updateUserInput(value, subLeverId, rowNumber)),
		fetchValueStories: (id) => dispatch(fetchValueStories(id)),
		fetchUserSharedValueStories: (id) => dispatch(fetchUserSharedValueStories(id)),
		getSPCapitalIQSuccess: message => dispatch(getSPCapitalIQSuccess(message)),
		getSPCapitalIQFailure: error => dispatch(getSPCapitalIQFailure(error)),
		getSPCapitalIQLoading: bool => dispatch(getSPCapitalIQLoading(bool)),
		getSPCapitalIQData: (CapIQID) => dispatch(getSPCapitalIQData(CapIQID)),
		capIQFetchData: (capIQData) => dispatch(capIQFetchData(capIQData)),
		getCapIQDataBlank: bool => dispatch(getCapIQDataBlank(bool)),
		updateBPID: (data) => dispatch(updateBPID(data)),
		updateANID: (data) => dispatch(updateANID(data)),
		updateValueStoryType: (data) => dispatch(updateValueStoryType(data)),
		updateRegion: (data) => dispatch(updateRegion(data)),
		fetchIndirectVisibleSolutionInScopeValues: () => dispatch(fetchIndirectVisibleSolutionInScopeValues()),
		updateValueStoryFailure: (error) => dispatch(updateValueStoryFailure(error)),		
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(SpendDiscoveryForm)